import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./productlayout.css";
import { db } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import SliderComponent from "../Carousel/SliderComponent";
import Skeleton from "@mui/material/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { ProductActions } from "../../store/ProductSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { Button } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [wishlist, setWishlist] = useState(
    JSON.parse(localStorage.getItem("wishlist")) || []
  );

  const productsCollectionRef = collection(db, "products");
  const navigator = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      const snapshot = await getDocs(productsCollectionRef);
      setProducts(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };

    fetchProducts();
  }, []);

  const dispatch = useDispatch();

  const handleProductClick = (product) => {
    dispatch(ProductActions.viewProduct(product));
  };

  const toggleWishlist = (product) => {
    const isWishlisted = wishlist.some((item) => item.id === product.id);
    const updatedWishlist = isWishlisted
      ? wishlist.filter((item) => item.id !== product.id)
      : [...wishlist, product];

    setWishlist(updatedWishlist);
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));

    toast.success(
      isWishlisted ? "Removed from wishlist." : "Added to wishlist.",
      {
        position: "top-right",
      }
    );
  };
  const addtocart = (product) => {
    const existingCartItems = JSON.parse(localStorage.getItem("incart")) || [];
    const existingProductIndex = existingCartItems.findIndex(
      (item) => item.id === product.id && item.size === 2.6
    );

    if (existingProductIndex >= 0) {
      existingCartItems[existingProductIndex].quantity += 1;
    } else {
      const productWithQuantity = {
        ...product,
        size: 2.6,
        quantity: 1,
      };
      existingCartItems.push(productWithQuantity);
    }

    localStorage.setItem("incart", JSON.stringify(existingCartItems));

    toast.success("Product added to Cart.", { position: "top-left" });
  };
  return (
    <>
      <div className="container">
        {products.map((product) => (
          <div className="product-wrapper" key={product.id}>
            <div
              className="wishlist-icon"
              onClick={() => toggleWishlist(product)}
            >
              {wishlist.some((item) => item.id === product.id) ? (
                <FavoriteIcon className="heart-icon active" />
              ) : (
                <FavoriteBorderIcon className="heart-icon" />
              )}
            </div>

            <Link
              to={`/product/${product.ProductName}`}
              className="product-link"
            >
              <div onClick={() => handleProductClick(product)} key={product.id}>
                {product.ProductImgs ? (
                  <>
                    <SliderComponent images={product.ProductImgs} />
                    <div className="ratingcount">
                      {" "}
                      <StarIcon /> | 56
                      {/* {product.ProductRating} */}
                    </div>
                  </>
                ) : (
                  <>
                    <Skeleton animation="wave" />
                  </>
                )}
              </div>
            </Link>

            <div className="info">
              <div className="product-description">
                <div className="prdctName">{product.ProductName}</div>
                <span className="Mrpprice">
                  <span className="price"> Rs.{product.ProductPrice}/-</span>
                  <span className="Mrp">
                    {(
                      product.ProductPrice +
                      (product.ProductPrice * 30) / 100
                    ).toFixed(2)}
                    /-
                  </span>
                </span>
              </div>
              <div className="addcart">
                <Button
                  variant="contained"
                  className="add-to-cart"
                  color="inherit" // This removes the default Material-UI color
                  onClick={() => addtocart(product)}
                >
                  Add to Cart
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductList;
